import {Component, OnInit} from '@angular/core';
import {User} from "../models/user";
import {firstValueFrom, Observable} from "rxjs";
import {Event} from "../models/event";
import {Organization} from "../models/organization";
import {EventService} from "../services/event.service";
import {OrganizationService} from "../services/organization.service";
import {AuthenticationService} from "../services/authentication.service";
import {RegistrationService} from "../services/registration.service";
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'app-event-detail-page',
    templateUrl: './event-detail-page.component.html',
    styleUrls: ['./event-detail-page.component.css'],
    standalone: false
})
export class EventDetailPageComponent implements OnInit {
  user!: User;
  organization!: Organization;
  event$!: Observable<Event>;
  signees: User[] = [];

  constructor(
    private eventService: EventService,
    private orgService: OrganizationService,
    private authService: AuthenticationService,
    private regService: RegistrationService,
    private route: ActivatedRoute
  ) {
  }

  async ngOnInit() {
    try {
      const params = await firstValueFrom(this.route.paramMap);
      const ref = params.get('id');

      if (ref != null) {
        this.event$ = this.eventService.getEventByRef(ref);
        this.user = await this.authService.getUser();
        this.organization = await firstValueFrom(this.orgService.getOrganizationByRef(this.user.organization));

        this.regService.getRegistrationsByEvent(ref).subscribe(
          regs => {
            regs.forEach((reg) => {
              this.authService.getUserDetails(reg.user.path).subscribe(user => {
                this.signees.push(user.data as User);
              })
            });
          }
        );
      }
    } catch (error) {
      console.error("Error occurred: ", error);
    }
  }
}
